var _templateObject, _templateObject2, _templateObject3;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { styled, css } from '@creditas-ui/system';
import { variant, ifNotProp } from '@creditas-ui/utilities';
import { Skeleton } from '../../base/Skeleton';

var base = _ref => {
  var {
    theme: {
      skeleton
    }
  } = _ref;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: ", ";\n"])), skeleton('shapes.rectangle.base.borderRadius'));
};

var margin = _ref2 => {
  var {
    theme: {
      skeleton
    }
  } = _ref2;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n"])), skeleton('shapes.rectangle.base.marginBottom'));
};

var variantStyles = _ref3 => {
  var {
    theme: {
      skeleton
    }
  } = _ref3;
  return variant({
    prop: 'variant',
    variants: {
      heading: skeleton('shapes.rectangle.heading'),
      body: skeleton('shapes.rectangle.body')
    }
  });
};

export var SkeletonLine = styled(Skeleton)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n"])), base, ifNotProp('isLast', margin), ifNotProp('height', variantStyles));
//# sourceMappingURL=SkeletonText.styles.js.map